import { useIntl, useSetPageTitle, useSettings } from '@capsicum/common';
import { Button, useRouter } from '@capsicum/common-web';
import { PlusIcon } from '@capsicum/common-web/icons';
import { useNCWPartnerDetails } from '@capsicum/features/nc-wallet/shared';
import { SellEntrypoint, ShortCode, useNCWBalance } from '@capsicum/socios-core';
import { StakedSection } from 'libs/features/wallet/web/src/feature/wallet-partner-details/sections';
import { BuySellButtonsSection } from 'libs/features/wallet/web/src/feature/wallet-partner-details/sections/BuySellButtonsSection';
import { useParams } from 'next/navigation';

import { ChilizOrTokenCard } from './ChilizOrTokenCard';
import * as S from './NCWPartnerDetails.styled';
import { NftsSection } from './sections';

export const NCWPartnerDetails = () => {
	const {
		settings: { isTopupEnabled }
	} = useSettings();
	const params = useParams();
	const { $t } = useIntl();
	const tokenShortCode = (params?.partnerShortCode || '') as string;
	const { chilizBalance, getTokenBalanceBy, isPending, ncwBalance } = useNCWBalance();
	const { currencyId, intlText, partnerId } = useNCWPartnerDetails(tokenShortCode, ncwBalance);
	const { push } = useRouter();

	useSetPageTitle(intlText.pageTitle);

	return (
		<S.Wrapper>
			<S.Sections>
				<ChilizOrTokenCard
					chilizBalance={chilizBalance}
					getTokenBalanceBy={getTokenBalanceBy}
					isPending={isPending}
					tokenShortCode={tokenShortCode}
				/>
				{tokenShortCode === ShortCode.CHZ ? (
					<S.ButtonsWrapper>
						<Button
							disabled={!isTopupEnabled}
							fullWidth
							iconStart={{ icon: { src: PlusIcon } }}
							testID="top-up-button-chiliz-partner-details"
							text={$t('ncWallet.home.topup')}
							onClick={() => push('/nc-wallet/topup')}
						/>
					</S.ButtonsWrapper>
				) : (
					<BuySellButtonsSection
						entrypoint={SellEntrypoint.WalletPartner}
						fanTokenCurrencyId={currencyId!}
						partnerId={partnerId}
					/>
				)}
			</S.Sections>
			<StakedSection partnerId={partnerId!} shortCode={tokenShortCode} />
			<NftsSection partnerId={partnerId!} />
			{/** TODO: to develop the Transaction History List when BE API is available */}
			{/** use common-web/List component to render the list. Referrence: Web TransactionCardsByDay.tsx */}
		</S.Wrapper>
	);
};
